const convertToNumberWithComma = (num, fractionDigits = 2) => {
  const regex = new RegExp(`\,0{${fractionDigits}}`);

  return (
    num
      .toFixed(fractionDigits)
      .replace('.', ',')
      .replace(regex, '')
  );
};

const NumberFormatter = {
  convertToNumberWithComma,
};

export { NumberFormatter };
